// FORMAT PRODUCT ITEM FOR CART
export function formatCartEssentialOption(option, productIdList) {
  return {
    productId: option.entity_id ? option.entity_id : (option.product_id ? option.product_id : "") ,
    thumbnail: option.thumbnail ?? "",
    price: option.price ?? false,
    name: option.name ?? "",
    description: option.description ?? "",
    entityId: option.item_id ?? "",
    isInCart: productIdList.includes(option.entity_id) ? true : false,
    tva: option.tax_percent,
  };
}
